/** -------------------- PROCESS VARIABLES -------------------- **/
/**
 * FREEPAD_RULES
 *
 * Each rule defines a vendor and a minimum price (in cents) required to qualify for a free pad.
 *
 * How it works:
 * - Match the variant's vendor to a rule in FREEPAD_RULES
 * - If a match is found, check the price
 * - If variant price >= priceThreshold, it qualifies for a free pad
 * - If no matching vendor rule exists, it does not qualify
 *
 * Notes:
 * - Prices are stored in cents (e.g. 34900 = $349.00)
 * - One rule per vendor is expected
 */


function setFreePadProperty(form, shouldAdd) {
  form.querySelector('[name="properties[Bonus]"]')?.remove();
  if (!shouldAdd) return;
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'properties[Bonus]';
  input.value = '+ Free Pad (Ships Separately)';
  form.appendChild(input);
}

const returnText = `
    <div class="accordion__content fs-body-100 rte non-page-rte measure" aria-hidden="false" id="accordion-content-accordion-1" data-default-expanded="false" data-measured="true" style="display: block;">
      <p>This item qualifies for the following Return Policy:</p>
        <ul>
          <li>Free return shipping on one Sample Swatch or 2'x4' area rug when 5x8 or larger is ordered.</li>
          <li>30 day return period. </li>
          <li>No Restocking Fees. Customer pays only for return shipping costs. </li>
          <li>Discounted UPS/Fedex return shipping labels available. (<a href="https://incrediblerugsanddecor.com/pages/contact-us" target="_blank">Contact us</a> for pricing.)</li>
        </ul>
        <p>See our full&nbsp;<a href="https://incrediblerugsanddecor.com/pages/policies" target="_blank">store policies</a>&nbsp;page for full return policy details.</p>
        <p>To return an item, visit our <a href="https://incrediblerugsanddecor.com/pages/returns" target="_blank">returns page</a>.</p>
    </div>
`;

const cannotReturnText = `
    <div class="accordion__content fs-body-100 rte non-page-rte measure" aria-hidden="false" id="accordion-content-accordion-1" data-default-expanded="false" data-measured="true" style="display: block;">
      <p>Custom Rugs are not eligible for returns.</p>
    </div>
`;

function initializeReturnInfo(){
  function getCurrentProducts(){
    try {
      let initialProduct = document.querySelectorAll('[id*="variantchange_productData_"]');
      const productLength = initialProduct.length;
      if(initialProduct.length > 0){
        return JSON.parse(initialProduct[0].innerText.trim());
      } return null;
    }catch(err){
      console.error(err);
      return null;
    };
  };
  function getAllReturnDivs(){
    let returnTextDivs = document.querySelectorAll('[id*="returnText"]');
    if(returnTextDivs.length > 0){
      return returnTextDivs;
    } else return null;
  };
  function setReturnData(){
    const products = getCurrentProducts();
    let returnDivs = getAllReturnDivs();
    if(products !== null && returnDivs !== null){
      const divsLength = returnDivs.length;
      for(let it = 0; it < divsLength; it++) {
          returnDivs[it].innerHTML = '';
          let tempElement = document.createElement("div");
          if(products.tags.includes('Group-Cut and Sew') || products.tags.includes('Made To Order') && (!products.vendor.includes('Dalyn') && !products.vendor.includes('Piper Loom'))) 
            tempElement.innerHTML = cannotReturnText.trim();
          else tempElement.innerHTML = returnText.trim();
          returnDivs[it].appendChild(tempElement);
      };
    };
  };
  setReturnData();
};

/* -------------------- TEXT FILTERS -------------------- */

const freeText = (normalizedText) => `${normalizedText} +&nbsp; Free Pad`;

function getShopifyVariantIdFromBrowser() {
  const params = new URLSearchParams(window.location.search);
  const variantId = params.get("variant");
  return variantId ? Number(variantId) : null;
}

function initializeProductTextFilters() {
  const SELECTOR = `button#displayedProductOptions,h1#displayedProductOptions,h2#displayedProductOptions,h3#displayedProductOptions,p#displayedProductOptions`;
  const processElement = (el, variants, rule) => {
    const rawText = el.textContent.trim();
    const normalizedText = ProductCore.normalize(rawText);
    const variant = ProductCore.findVariantByTitle(variants, rawText);
    if (!variant || !rule) {
      el.textContent = normalizedText;
      return;
    }
    if ((variant.price > rule.priceThreshold) && rule.type.toLowerCase() === "rugs") el.innerHTML = freeText(normalizedText);
    else el.textContent = normalizedText;
  };
  const init = () => {
    const product = ProductCore.getProduct();
    if (!product) return;
    const variants = ProductCore.getVariants(product);
    const rule = ProductCore.findVendorRule(product.vendor);
    rule.type = product.type;
    document.querySelectorAll(SELECTOR).forEach(el => processElement(el, variants, rule) );
  };

  document.addEventListener("DOMContentLoaded", init);
}

initializeReturnInfo();
initializeProductTextFilters();